/**
 * The home page as a route module (web plan W4.5): `/` and, after the URL move, `/{cc}/{lang}`,
 * registered in src/routes.ts.
 *
 * The server loader reads the SEO server's answer for the URL (status,
 * redirect, head and the page's query answers; @/seo/pageDocument), so the
 * document's body is the real page, not a loading state. In-app navigations
 * load through Apollo, as before.
 */
import type { LoaderFunctionArgs } from 'react-router';
import { PageRoute } from '@/components/seo/PageRoute';
import { RouteErrorBoundary } from '@/components/seo/RouteErrorBoundary';
import { useLocation } from 'react-router-dom';
import CountryChooserPage from '@/pages/CountryChooserPage';
import HomePage from '@/pages/HomePage';
import { loadPageDocument, pageClientLoader, pageHeaders, pageMeta } from '@/seo/pageDocument';
import { chooserLive } from '@/seo/urls';

export function loader({ context }: LoaderFunctionArgs) {
  return loadPageDocument(context);
}

export function clientLoader() {
  return pageClientLoader();
}

/** The document uses the server loader's data; only in-app navigations run `clientLoader`. */
clientLoader.hydrate = false as const;

export const headers = pageHeaders;

export const meta = pageMeta;

export const ErrorBoundary = RouteErrorBoundary;

export default function HomeRoute() {
  // `/` is the country chooser while its switch is on (web plan MW10).
  const { pathname } = useLocation();
  return (
    <PageRoute catalogPath="/">{chooserLive() && pathname === '/' ? <CountryChooserPage /> : <HomePage />}</PageRoute>
  );
}
